import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { useParams } from "react-router-dom";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { decodeId } from "../utills/idUtils";
import FancyLoader from "../hooks/FancyLoder";

const API_URL = process.env.REACT_APP_API_URL;

const StatementWiseScore = ({ isGeneratingPdf, pdfState,assessment_type }) => {
  console.log(assessment_type,"assessment_type")
  const { encodedId } = useParams();
  const id = decodeId(encodedId);
  const { state } = useAuth();
  const { user } = state;
  const getUserDetails = user;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [asmt_type, setAsmt_type] = useState(false);
  const [componentScores, setComponentScores] = useState([]); // Added state for component scores

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch component scores
        const componentScoreResponse = await axios.get(
          `${API_URL}/components-score/${id}`
        );
        const componentScoresData = componentScoreResponse.data;
        console.log("componentScoresData", componentScoresData);
        setComponentScores(componentScoresData);

        // Fetch statements scores
        const response = await axios.get(`${API_URL}/statements-score/${id}`);
        const fetchedData = response.data;
        // console.log("rsponse===>>>", fetchedData)
        // Process statements data
        const processedData = fetchedData.map((item) => ({
          statement_id: item.statement_id,
          statement_text: item.other_statement_text.replace(
            /{{assessee}}/g,
            getUserDetails?.first_name
          ),
          self_statement_text: item.self_statement_text,
          initiator:
            item.association_type === "initiator"
              ? parseFloat(item.value)
              : null,
          participant:
            item.association_type === "participant"
              ? parseFloat(item.value)
              : null,
          component_name: item.component_name,
          pillar_name: item.pillar_name,
          pg_brk_self: item.pg_brk_self,
          pg_brk_360: item.pg_brk_360,
        }));

        setData(processedData);

        // Check if there are any participant entries
        const hasInitiator = fetchedData.some(
          (item) => item.association_type !== "initiator"
        );
        setAsmt_type(hasInitiator);
      } catch (err) {
        setError(err.response ? err.response.data.message : err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, getUserDetails]);

  if (loading)
    return (
      <div>
        <FancyLoader />
      </div>
    );
  if (error) return <div>Error: {error}</div>;

  // Process table data and calculate `self` and `other` scores
  const tableData = data.reduce((acc, item) => {
    let {
      statement_id,
      statement_text,
      self_statement_text,
      initiator,
      participant,
      component_name,
      pillar_name,
      pg_brk_self,
      pg_brk_360,
    } = item;
    // console.log("self_statement_text", self_statement_text)

    if (!acc[statement_id]) {
      acc[statement_id] = {
        statement_text: asmt_type ? statement_text : self_statement_text,
        initiator: null,
        participant: null,
        component_name,
        pillar_name,
        self: 0,
        other: 0,
        pg_brk_self: item.pg_brk_self,
        pg_brk_360: item.pg_brk_360,
      };
    }

    // Assign initiator and participant values
    if (initiator !== null) acc[statement_id].initiator = initiator;
    if (participant !== null) acc[statement_id].participant = participant;

    const componentScoresForComponent = componentScores.filter(
      (score) => score.component_name === component_name
    );

    // console.log("componentScoresForComponent", componentScoresForComponent)
    // If there are matching scores for the component_name
    if (componentScoresForComponent.length > 0) {
      // Initialize the accumulator for this statement_id if not already done
      acc[statement_id] = acc[statement_id] || { self: 0, other: 0 };

      // Loop through all matching component scores
      componentScoresForComponent.forEach((score) => {
        // Parse the value from the 'sum(aua.answer_value)' field
        const answerValue = parseFloat(score["sum(aua.answer_value)"]);

        // Check if parsing was successful
        if (isNaN(answerValue)) {
          console.error(
            "Error: Unable to parse answer_value",
            score["sum(aua.answer_value)"]
          );
        } else {
          // Add the parsed value to the correct accumulator
          if (score.association_type === "initiator") {
            acc[statement_id].self = answerValue; // Add to 'self' for initiator
          }

          if (score.association_type === "participant") {
            acc[statement_id].other = answerValue; // Add to 'other' for participant
          }
        }
      });
    } else {
      console.log(
        "No component scores found for the specified component name."
      );
    }

    return acc;
  }, {});

  // Convert the object into an array of values
  const finalTableData = Object.values(tableData);

  console.log(finalTableData, "fifinalTableDatanalTableData")

  const LegendD = ({ asmt_type }) => (
    <div
      className="lg:flex items-start justify-start gap-6  p-4"
      style={{ display: "flex" }}
    >
      <div style={{ pageBreakBefore: "always" }}></div>
      {/* {asmt_type && (
        <div className="lg:flex items-center gap-2">
                <div className="lg:flex items-center gap-2">
        <div className="w-4 h-4 bg-indigo-500 rounded-full"></div>
        <span className="text-sm text-gray-600">Self Score</span>
      </div>
      
          <div
            className="w-4 h-4 bg-cyan-400 rounded-full"
            style={{ background: "rgb(34 211 238 / var(--tw-bg-opacity, 1))" }}
          ></div>
          <span className="text-sm text-gray-600">
            Respondents Average Score{" "}
          </span>
        </div>
      )}      )} */}
    </div>
  );

  return (
    <div className="p-4 lg:px-16 statement-row">
      <div
        className="flex flex-wrap bg-[#F0F0F0] rounded-lg"
        style={{ background: "rgb(230 230 230  / var(--tw-bg-opacity, 1))" }}
      >
        {/* Legend and Section Header */}

        <div className="w-full pt-4">
          <LegendD asmt_type={asmt_type} />
          <div className="bg-blue-700 w-full grid items-center min-h-12 py-1  ">
            <h3
              className="text-white text-lg font-bold px-4  my-0"
              style={{ fontFamily: "Helvetica" }}
            >
              SECTION 2: Detailed Breakdown by Element
            </h3>
          </div>
        </div>

        {/* Group data by pillars */}
        <div className="lg:flex flex-wrap w-full p-4">
          {finalTableData
            .reduce((acc, item) => {
              // Grouping by pillar_name
              const pillarGroup = acc.find(
                (group) => group.pillar_name === item.pillar_name
              );
              if (pillarGroup) {
                pillarGroup.components.push(item); // Adding component to existing pillar
              } else {
                acc.push({ pillar_name: item.pillar_name, components: [item] }); // Creating new pillar group
              }
              return acc;
            }, [])
            .map((pillarGroup, pillarIndex) => (

              <div key={pillarIndex} className="w-full">
                {/* {pillarGroup.pillar_name === "POWERFUL BEING" && (
                  <div style={{ pageBreakAfter: "always" }}></div>
                )} */}

                {/* <h3
                  className="text-lg font-semibold mb-4 p-1 bg-blue-300"
                  style={{ fontFamily: "Helvetica" }}
                >
                  {pillarGroup.pillar_name}
                </h3> */}

                {[
                  ...new Map(
                    pillarGroup.components.map((item) => [
                      item["component_name"],
                      item,
                    ])
                  ).values(),
                ].map((element, elementIndex) => (
                  <div key={elementIndex}
                    className="mb-2 page-break"
                    // 
                    style={
                     (element.component_name === "COLLABORATE" && assessment_type === "self") ||
                     (assessment_type === "360" && element.component_name === "CONNECTION")
                        ? { pageBreakBefore: "always" }
                        : {}
                    }
                  >
                    {/* {isGeneratingPdf && elementIndex > 0 && (elementIndex) % 2 !== 0 && pdfState && pdfState.addPage()} */}

                    <p
                      className="text-gray-500 bg-blue-200 p-2 rounded"
                      style={{ 
                        fontFamily: "Helvetica",
                        marginTop:"10px" 
                      }}
                    >
                      <span className="font-semibold">
                        {element.component_name}
                      </span>
                      &nbsp;&nbsp;&nbsp;{" "}
                      <span className="inline-block w-4 h-4 bg-indigo-500 rounded-full"></span>
                      &nbsp;Self Score:{" "}
                      <span className="font-semibold">
                        {(((element.self + 2 || 0) / 16) * 5).toFixed(2)}
                      </span>
                      &nbsp;&nbsp;&nbsp;
                      {asmt_type && (
                        <>
                          <span
                            style={{
                              // backgroundColor: "#06b6d4",
                              background: "rgb(34 211 238 / var(--tw-bg-opacity, 1))",
                            }}
                            className="inline-block w-4 h-4 bg-cyan-500 rounded-full"></span>
                          &nbsp;Respondents Average Score:{" "}
                          <span className="font-semibold">
                            {(((element.other + 2 || 0) / 16) * 5).toFixed(2)}
                          </span>
                        </>
                      )}
                    </p>

                    {/* Render Statements for the Element */}
                    {pillarGroup.components
                      .filter(
                        (item) => item.component_name === element.component_name
                      )
                      .map(
                        (
                          {
                            statement_text,
                            initiator,
                            participant,
                            pg_brk_self,
                            pg_brk_360,
                          },
                          statementIndex
                        ) => {
                          const maxScore = 5;
                          let initiatorScaledScore =
                            ((initiator || 0) / maxScore) * 5;
                          let participantScaledScore =
                            ((participant || 0) / maxScore) * 5;
                          if (initiatorScaledScore < 0) {
                            initiatorScaledScore =
                              Math.abs(initiatorScaledScore);
                          }
                          if (participantScaledScore < 0) {
                            participantScaledScore = Math.abs(
                              participantScaledScore
                            );
                          }
                          const participantPercentage =
                            (participantScaledScore / 5) * 100;
                          const initiatorPercentage =
                            (initiatorScaledScore / 5) * 100;

                          return (
                            <div
                              key={statementIndex}
                              className="mb-4 w-full lg:p-4"
                            >
                              {pg_brk_self === "Y" && participant === null && (
                                <div style={{ pageBreakAfter: "always" }}></div>
                              )}
                              {pg_brk_360 === "Y" && participant !== null && (
                                <div style={{ pageBreakAfter: "always" }}></div>
                              )}
                              {/* Question and Bars in a Row on All Screens */}
                              <div className="flex flex-col lg:flex-row items-start w-full space-y-2 lg:space-y-0 lg:space-x-4">
                                {/* Question Section */}
                                <div className="w-full lg:w-1/3 mt-2">
                                  <h4
                                    className={`text-gray-700 font-medium `}
                                    style={{
                                      fontSize: isGeneratingPdf ? '13px' : '16px',
                                      fontFamily: "Helvetica",
                                    }}
                                  >
                                    {/* COMMUNICATION component name print */}
                                    {/* 1. I effectively generate enthusiasm and energy around my ideas. */}
                                    {statementIndex + 1}. {statement_text}
                                    {statementIndex === 3 ? "(Derailer)" : ""}
                                  </h4>
                                </div>

                                {/* Bars Section */}
                                <div className="w-full lg:w-2/3">
                                  {/* Initiator Score & Bar (Always Row Layout) */}
                                  <div className="flex flex-row items-center space-x-3">
                                    {/* Score on the Left */}
                                    <span
                                      className={`text-gray-800 text-xs min-w-[45px] flex items-center justify-end  rounded px-2 ${isGeneratingPdf ? "mt-2 h-2" : "mt-4 h-6"
                                        }`}
                                    >
                                      {/* {initiatorScaledScore.toFixed(2)} */}
                                    </span>
                                    <div className="flex-1">
                                      <div
                                        className={`bar-labels flex justify-between ${isGeneratingPdf ? "mb-3" : "mb-1"
                                          }`}
                                      >
                                        {[
                                          `     `,
                                          `1-Strongly Disagree`,
                                          `2-Disagree`,
                                          `3-Neutral`,
                                          `4-Agree`,
                                          `5-Strongly Agree`,
                                        ].map((label) => (
                                          <span
                                            key={label}
                                            className="text-xs text-gray-500"
                                          >
                                            {label}
                                          </span>
                                        ))}
                                      </div>
                                      <div className={`relative w-full ${isGeneratingPdf ? "h-4" : "h-6"} bg-gray-400 rounded`}>
                                        <table style={{ width: "100%" }}>
                                          <tbody>
                                            <tr>
                                              <td
                                                style={{
                                                  width: "100%",
                                                  padding: 0,
                                                  textAlign: "left",
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    width: `${(initiatorScaledScore /
                                                      5) *
                                                      100
                                                      }%`,
                                                    backgroundColor: "#6366f1", // Tailwind's indigo-500
                                                    height: isGeneratingPdf ? "15px" : "24px",
                                                    borderRadius: "4px",
                                                    textAlign: "left",
                                                    color: "white",
                                                    paddingRight: "4px",
                                                    paddingLeft: "4px",
                                                    fontSize: isGeneratingPdf ? "12px" : "15px",
                                                  }}
                                                >
                                                  {initiatorScaledScore.toFixed(
                                                    2
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Participant Score & Bar (Always Row Layout) */}
                                  {participant !== null && (
                                    <div className="flex flex-row items-center space-x-3 mt-2">
                                      {/* Score on the Left */}
                                      <span
                                        className={`text-gray-800 text-xs min-w-[45px] flex items-center justify-end  rounded px-2 ${isGeneratingPdf ? "mb-3 h-2" : " mt-1 h-6"
                                          }`}
                                      >
                                        {/* {participantScaledScore.toFixed(2)} */}
                                      </span>
                                      <div className="flex-1">
                                        <div className={`relative w-full ${isGeneratingPdf ? "h-4" : "h-6"} bg-gray-400 rounded `}>
                                          <table style={{ width: "100%" }}>
                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    width: "100%",
                                                    padding: 0,
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      width: `${participantPercentage}%`,
                                                      backgroundColor:
                                                        "#3FC8E4", // Tailwind's indigo-500
                                                      height: isGeneratingPdf ? "15px" : "24px",
                                                      borderRadius: "4px",
                                                      textAlign: "left",
                                                      color: "white",
                                                      paddingRight: "4px",
                                                      paddingLeft: "4px",
                                                      fontSize: isGeneratingPdf ? "12px" : "15px",
                                                    }}
                                                  >
                                                    {participantScaledScore.toFixed(
                                                      2
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        }
                      )}
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default StatementWiseScore;
